import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, _toDisplayString(_ctx.reservationCampaign.name), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.reservationCampaignPeriod), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.reservationCampaign.status.description), 1),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: {name: 'edit-reservation-campaign', params: {id: _ctx.reservationCampaign.id}},
          class: "btn btn-icon btn-primary ms-2"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}